import type { PieceJointeContentProps } from "../../lib/types";
import { cn } from "@repo/utils";

export default function FactureLeccoConstructionPJ({
  variablesData,
}: PieceJointeContentProps) {
  return (
    <>
      <div className={cn("flex items-center justify-between")}>
        <div className={cn("flex w-[10rem] flex-col")}>
          <img src="/logos/lecco.png" alt="logo_lecco" height={150} width={150} />
        </div>
        <div className={cn("mr-36 font-bold underline")}>
          FACTURE N°225/3714 BH
        </div>
      </div>

      <div
        className={cn(
          "flex w-full flex-col items-center border-4 border-black bg-gray-300"
        )}
      >
        <div className={cn("font-bold")}>
          {variablesData.lecco_gerant_societe}
        </div>
        <div className={cn("font-bold")}>999 Chemin des ducs</div>
        <div className={cn("font-bold")}>57000 METZ</div>
        <div>{variablesData.societe_nom}</div>
        <div>102 Allée du Plein-Soleil </div>
        <div>54000 NANCY </div>
        <div className={cn("mt-8")}>Référence devis : SOUMISSION N ° 225</div>
        <div>
          OBJET: <span>atelier de production</span>{" "}
        </div>
      </div>

      <table className={cn("border-x-4 border-t-4 border-black bg-gray-300")}>
        <tbody>
          <tr>
            <td className={cn("w-[30rem]")}></td>
            <td
              className={cn("w-40 border-x-[1px] border-gray-400 text-center")}
            >
              COUT HORAIRE
            </td>
            <td className={cn("w-40 text-center")}>TOTAL HT </td>
          </tr>
        </tbody>
      </table>

      <table className={cn("border-4 border-black bg-gray-300")}>
        <thead>
          <tr className={cn("border-b-[1px] border-gray-400")}>
            <th className={cn("flex w-[30rem] justify-center")}>
              <div>{`MAIN-D'OEUVRE`}</div>
            </th>
            <th className={cn("w-40 text-center")}></th>
            <th className={cn("w-40 text-center")}></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={cn("h-8 w-[30rem] text-center")}></td>
            <td className={cn("w-40")}></td>
            <td className={cn("w-40 text-center")}></td>
          </tr>
          <tr className="">
            <td className={cn("flex w-[30rem] justify-center space-x-10")}>
              <div className={cn("w-40 text-center")}>Menuisier</div>
              <div className={cn("w-40 text-center")}>8 jours x 8 heures</div>
            </td>
            <td
              className={cn("w-42 border-x-[1px] border-gray-400 text-center")}
            >
              19 € / H
            </td>
            <td className={cn("w-42 text-center")}>1 216 €</td>
          </tr>
          <tr>
            <td className={cn("flex w-[30rem] justify-center space-x-10")}>
              <div className={cn("w-40 text-center")}>Manoeuvre</div>
              <div className={cn("w-40 text-center")}>30 jours x 8 heures</div>
            </td>
            <td
              className={cn("w-40 border-x-[1px] border-gray-400 text-center")}
            >
              15 € / H
            </td>
            <td className={cn("w-40 text-center")}>3 600 €</td>
          </tr>
          <tr>
            <td className={cn("flex w-[30rem] justify-center space-x-10")}>
              <div className={cn("w-40 text-center")}>Electricien</div>
              <div className={cn("w-40 text-center")}>6 jours x 8 heures</div>
            </td>
            <td
              className={cn("w-40 border-x-[1px] border-gray-400 text-center")}
            >
              19 € / H
            </td>
            <td className={cn("w-40 text-center")}>912 €</td>
          </tr>
          <tr>
            <td className={cn("flex w-[30rem] justify-center space-x-10")}>
              <div className={cn("w-40 text-center")}>Plombier</div>
              <div className={cn("w-40 text-center")}>3 jours x 8 heures</div>
            </td>
            <td
              className={cn("w-40 border-x-[1px] border-gray-400 text-center")}
            >
              24 € / H
            </td>
            <td className={cn("w-40 text-center")}>576 €</td>
          </tr>
          <tr>
            <td className={cn("h-8 w-[30rem] text-center")}></td>
            <td className={cn("w-40")}></td>
            <td className={cn("w-40")}></td>
          </tr>
          <tr className={cn("border-4 border-black font-bold")}>
            <td className={cn("h-8 w-[30rem] text-center")}>SOUS-TOTAL</td>
            <td className={cn("w-40")}></td>
            <td className={cn("w-40 text-center")}>6 304 €</td>
          </tr>
        </tbody>
      </table>

      <table className={cn("border-4 border-black bg-gray-300")}>
        <thead>
          <tr className={cn("border-b-[1px] border-gray-400")}>
            <th className={cn("h-8 w-[30rem] text-center")}>{`MATERIAUX`}</th>
            <th className={cn("w-40")}></th>
            <th className={cn("w-40")}></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={cn("h-8 w-[30rem] text-center")}></td>
            <td className={cn("w-40")}></td>
            <td className={cn("w-40 text-center")}></td>
          </tr>
          <tr>
            <td className={cn("w-[30rem] text-center")}>Solage</td>
            <td
              className={cn("w-40 border-x-[1px] border-gray-400 text-center")}
            ></td>
            <td className={cn("w-40 text-center")}>6 100 €</td>
          </tr>
          <tr>
            <td className={cn("w-[30rem] text-center")}>
              Coùt de la structure préfabriquée
            </td>
            <td
              className={cn("w-40 border-x-[1px] border-gray-400 text-center")}
            ></td>
            <td className={cn("w-40 text-center")}>19 670 €</td>
          </tr>
          <tr>
            <td className={cn("w-[30rem] text-center")}>Matériel électrique</td>
            <td
              className={cn("w-40 border-x-[1px] border-gray-400 text-center")}
            ></td>
            <td className={cn("w-40 text-center")}>3 600 €</td>
          </tr>
          <tr>
            <td className={cn("w-[30rem] text-center")}>
              Matériel de plomberie
            </td>
            <td
              className={cn("w-40 border-x-[1px] border-gray-400 text-center")}
            ></td>
            <td className={cn("w-40 text-center")}>1 400 €</td>
          </tr>
          <tr>
            <td className={cn("w-[30rem] text-center")}>Matériel de finition</td>
            <td
              className={cn("w-40 border-x-[1px] border-gray-400 text-center")}
            ></td>
            <td className={cn("w-40 text-center")}>2 200 €</td>
          </tr>
          <tr>
            <td className={cn("h-8 w-48 text-center")}></td>
            <td className={cn("w-40")}></td>
            <td className={cn("w-40 text-center")}></td>
          </tr>
          <tr className={cn("border-4 border-black font-bold")}>
            <td className={cn("h-8 w-[30rem] text-center")}>SOUS-TOTAL</td>
            <td className={cn("w-40")}></td>
            <td className={cn("w-40 text-center")}>32 970 €</td>
          </tr>
        </tbody>
      </table>

      <table className={cn("border-4 border-black bg-gray-300")}>
        <thead>
          <tr className={cn("border-b-[1px] border-gray-400")}>
            <th className={cn("h-8 w-[30rem] text-center")}>
              TOTAL CONSTRUCTION HT
            </th>
            <th className={cn("w-40")}></th>
            <th className={cn("w-40")}>39 274 €</th>
          </tr>
        </thead>
      </table>

      <table className={cn("border-4 border-black bg-gray-300")}>
        <thead>
          <tr>
            <th className={cn("w-40 border-[1px] border-black text-center")}>
              TOTAL HT
            </th>
            <th className={cn("w-40 border-[1px] border-black text-center")}>
              Taux T.V.A.
            </th>
            <th className={cn("w-40 border-[1px] border-black")}>
              TOTAL T.V.A.
            </th>
            <th className={cn("w-40 border-[1px] border-black")}>
              TOTAL T.T.C.
            </th>
          </tr>
          <tr>
            <th className={cn("w-40 border-[1px] border-black text-center")}>
              39 274 €
            </th>
            <th className={cn("w-40 border-[1px] border-black text-center")}>
              20 %
            </th>
            <th className={cn("w-40 border-[1px] border-black")}>7 855 €</th>
            <th className={cn("w-40 border-[1px] border-black")}>47 129 €</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </>
  );
}

FactureLeccoConstructionPJ.title = "Facture Lecco Construction";
